import { render, staticRenderFns } from "./workGasItem.vue?vue&type=template&id=247464bf"
import script from "./workGasItem.vue?vue&type=script&lang=js"
export * from "./workGasItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247464bf')) {
      api.createRecord('247464bf', component.options)
    } else {
      api.reload('247464bf', component.options)
    }
    module.hot.accept("./workGasItem.vue?vue&type=template&id=247464bf", function () {
      api.rerender('247464bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/base/workGasItem.vue"
export default component.exports